export default {
    restDays: "2023-12-30 2023-12-31 2024-01-01 2024-02-10 2024-02-11 2024-02-12 2024-02-13 2024-02-14 2024-02-15 2024-02-16 2024-02-17 2024-04-04 2024-04-05 2024-04-06 2024-05-01 2024-05-02 2024-05-03 2024-05-04 2024-05-05 2024-06-08 2024-06-09 2024-06-10 2024-09-15 2024-09-16 2024-09-17 2024-10-01 2024-10-02 2024-10-03 2024-10-04 2024-10-05 2024-10-06 2024-10-07",
    workDays: "2023-01-28 2023-01-29 2023-04-23 2023-05-06 2023-06-25 2023-10-07 2023-10-08 2024-02-04 2024-02-18 2024-04-07 2024-04-28 2024-05-11 2024-09-14 2024-09-29 2024-10-12",
    hours: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"],
    minutes: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59"],
    viewColor: [
        "#EDC7D8",
        "#C9E2CC",
        "#C8F5ED",
        "#DAD7F6",
        "#F1D9C3",
        "#B1DEEC",
        "#FDEEB1",
        "#E1CFF4",
        "#CBDFBA",
        "#D8E2DE",
        "#DCBCCD",
        "#B7CED4",
        "#89ADCD",
        "#D0E3EA",
        "#B1CAE1",
        "#DCD9E4",
        "#F1E3DD",
        "#EFD4D8",
        "#CEE9E0",
        "#CDEEF2",
        "#96DED8",
        "#B6DCB5",
        "#D6E8AA",
        "#FEECC1",
        "#FCE3E6",
        "#FCF9D5",
        "#FFBBBC",
        "#DAF1DC",
        "#D0E655",
        "#EDF1F2",
    ],

    view: {
        holidayItem: {
            "0101":"元旦",
            "0214":"情人节",
            "0308":"妇女节",
            "0401":"愚人节",
            "0501":"劳动节",
            "0601":"儿童节",
            "0801":"建军节",
            "0910":"教师节",
            "1001":"国庆节",
            "1224":"平安夜",
            "1225":"圣诞节"
        },
        holidayStr: " 除夕 春节 元宵节 端午节 七夕节 中秋节 重阳节 腊八节 北小年 南小年",
    },
}